module.exports = __webpack_public_path__ + "img/warning-icon.ebda001d.svg";